import { render } from "./AddressFormShort.vue?vue&type=template&id=07e3e5da&scoped=true"
import script from "./AddressFormShort.vue?vue&type=script&lang=js"
export * from "./AddressFormShort.vue?vue&type=script&lang=js"

import "./AddressFormShort.vue?vue&type=style&index=0&id=07e3e5da&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e3e5da"]])

export default __exports__